/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { AddressData } from './address';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/auto-order-setting-details';

export const AutoOrderSettingDetailApi = {
  findTotalChainOrderForOrder: async () => {
    const url = `${pathname}/total-chain-order-for-order`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findToOrderChainSuppliers: async (
    params: FindToOrderChainSuppliersOptions
  ) => {
    let url = `${pathname}/find-to-order-chain-suppliers`;
    const query = serialize(params.options);
    url += query;

    try {
      const response = await entityService.post(url, params.body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: UpdateAutoOrderSettingDetailBody) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateMulti: async (data: UpdateMultiAutoOrderSettingDetailBody) => {
    try {
      const url = `${pathname}/multi`;
      const response = await entityService.patch(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (data: CreateAutoOrderSettingDetailBody) => {
    try {
      const response = await entityService.post(pathname, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  refreshProposalItems: async (body: { pathID: string }) => {
    const url = `${pathname}/refresh-proposal-items`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (data: CreateMultiAutoOrderSettingDetailBody) => {
    try {
      const url = `${pathname}/multi`;
      const response = await entityService.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string, option: FindOptions) => {
    let url = `${pathname}/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: DeleteMultiAutoOrderSettingDetailBody) => {
    const url = `${pathname}/delete/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCustomerQuantityEqualProposedQuantity: async (id: string) => {
    const url = `${pathname}/update-customer-quantity-equal-proposed-quantity/${id}`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCustomerQuantityEqualProposedQuantityV2: async (id: string) => {
    const url = `${pathname}/update-customer-quantity-equal-proposed-quantity-v2/${id}`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindToOrderChainSuppliersOptions {
  options: {
    name?: string;
    page: number;
    take: number;
  };
  body: {
    ids?: string[];
    entityProductIDs?: string[];
    entityProducts: any;
    proposalItemPaths: any;
  };
}

export interface CreateAutoOrderSettingDetailBody {
  name: string;
  entityID: string;
  addressID: string;
  partnerPathID: string;
}

export interface CreateMultiAutoOrderSettingDetailBody {
  autoOrderSettingDetails: CreateAutoOrderSettingDetailBody[];
}

export interface UpdateAutoOrderSettingDetailBody {
  name?: string;
  addressID?: string;
  isOrderAll?: boolean;
  minimumOrderQuantity?: number;
  maxOrderQuantity?: number;
  pointDetail?: AutoOrderSettingDetailPointDetail;
}

export interface UpdateMultiAutoOrderSettingDetailBody {
  isOrderAll?: boolean;
  pointDetail?: AutoOrderSettingDetailPointDetail;
  autoOrderSettingDetailIDs: string[];
}

export interface DeleteMultiAutoOrderSettingDetailBody {
  autoOrderSettingDetailIDs: string[];
  page: number;
  take: number;
}

export interface AutoOrderSettingDetailPointDetail {
  deliveryPoint: number;
  quantityPoint: number;
  reportPoint: number;
}

export interface AutoOrderSettingDetail {
  id: string;
  name: string;
  entityID?: string;
  addressID?: string;
  partnerPathID?: string;
  address?: AddressData;
  isOrderAll?: boolean;
  minimumOrderQuantity?: number;
  maxOrderQuantity?: number;
  point?: number;
  pointDetail?: AutoOrderSettingDetailPointDetail;
  partnerPath?: {
    id: string;
    address: AddressData;
    chainPosition: number;
    createdAt: string;
    name: string;
    path: string[];
    toEntityID: string;
    fromEntityID: string;
  };
  status?: number;
  createdAt?: string;
  updatedAt?: string;
  isEditing?: boolean;
}
